import React from 'react';
import { toast } from 'react-hot-toast';

import StewartToast, { ToastType } from './StewartToast';

interface ShowToastProps {
  type: ToastType;
  title?: string;
  message?: string | JSX.Element;
  onClose?: () => void;
}

export const showToast = ({ type, title, message, onClose }: ShowToastProps) => {
  toast.custom(
    (t) => <StewartToast t={t} type={type} title={title} message={message} onClose={onClose} />,
    {
      duration: type === 'error' ? Infinity : 8000,
    }
  );
};
